import CardComponent from './card.component'

const CardModule = angular.module('cdbl.card', [

])
  .component('cdblCard', CardComponent)
  .name

export default CardModule
